<div *ngIf="navTo === 'm'">
  <lib-ph-bhp-view-month-consumption (childData)="onChildData($event)"></lib-ph-bhp-view-month-consumption>
</div>
<div *ngIf="navTo === 'y'">
   <lib-ph-bhp-view-year-consumption (childData)="onChildData($event)"></lib-ph-bhp-view-year-consumption>
</div>
<div *ngIf="navTo === 'q'">
  <lib-ph-bhp-view-quarter-consumption (childData)="onChildData($event)"></lib-ph-bhp-view-quarter-consumption>
</div>